export default {
    IS_DEVELOPMENT : _IS_DEVELOPMENT_,
    ONESIGNAL_APP_ID: 'b2a2d2d5-66f2-49e0-98d4-26d152dda9e3',
    ENABLE_PWA: _ENABLE_PWA_,
}
